import { Component, OnInit } from '@angular/core';
import { EPTabComponent } from './ep-tab.component';

@Component({
    selector: 'ep-tabs',
    templateUrl: './ep-tabs.component.html',
    styleUrls: ['./ep-tabs.component.scss']
})
export class EPTabsComponent implements OnInit {
    tabs: EPTabComponent[] = [];
    constructor() { }

    ngOnInit() {
    }

    addTab(tab: EPTabComponent) {
        if (this.tabs.length === 0) {
            tab.active = true;
        } else {
            tab.active = false;
        }
        this.tabs.push(tab);
    }

    selectTab(tab: EPTabComponent) {
        this.tabs.forEach((t) => {
            t.active = false;
        });
        tab.active = true;
    }

}
